module.exports = __webpack_public_path__ + "static/MineralSwimV2_Brochure_2026_FA_WEB-86997ec898ccd0ebca1c3d2b56aae69c.pdf";